import { Link, useParams } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router-dom'
import NavLink from './navLink'

const Pagination = ({ count = 40, pagesize = 4, page = 1, totalPage = 10 }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { page: urlPage, channel_id } = useParams()
  const searchParams = new URLSearchParams(location.search)
  const keyword = searchParams.get('keyword')

  const handleButtonClick = currentPage => {
    const path = location.pathname
      .replace(`${channel_id ? `/${channel_id}` : ''}`, '')
      .replace(`${urlPage ? `/${urlPage}` : ''}`, '')
    return `${path}/${channel_id ? channel_id : '0'}/${currentPage}${
      keyword ? `?keyword=${keyword}` : ''
    }`
  }

  const onChange = e => {
    navigate(handleButtonClick(e.target.value))
  }

  return (
    <div className="mt-14 mb-14 flex flex-wrap justify-center text-[#333333] font-sourceHan">
      <p>
        共{count}条记录，每页{pagesize}条，当前第{page}/{totalPage}页
      </p>
      <NavLink className="ml-2" to={handleButtonClick(1)}>
        第一页
      </NavLink>
      <p className="ml-2">|</p>
      <NavLink className="ml-2" to={handleButtonClick(page - 1 < 1 ? 1 : page - 1)}>
        上一页
      </NavLink>
      <p className="ml-2">|</p>
      <NavLink className="ml-2" to={handleButtonClick(page + 1 > totalPage ? totalPage : page + 1)}>
        下一页
      </NavLink>
      <p className="ml-2">|</p>
      <NavLink className="ml-2" to={handleButtonClick(totalPage)}>
        最末页
      </NavLink>
      <p className="ml-2">转到第</p>
      <select onChange={e => onChange(e)} value={page} className="ml-2 border border-[#AAAAAA]">
        {Array(totalPage)
          .fill('')
          .map((_, key) => (
            <option key={key} value={key + 1}>
              {key + 1}
            </option>
          ))}
      </select>
      <p className="ml-2">页</p>
    </div>
  )
}

export default Pagination
